import React from "react";
import { Zap, Landmark, FileText, Banknote, CircleDollarSign } from "lucide-react";

/** Canonical labels + colored icons for payment methods.
 * Keep this list in sync with the Select in InvoiceEditor's PaymentsCard.
 */
export const PAYMENT_METHOD_META = {
  paynow:        { label: "PayNow",        icon: Zap,               tone: "#7C3AED" }, // violet — PayNow brand
  bank_transfer: { label: "Bank Transfer", icon: Landmark,          tone: "#0EA5E9" }, // sky
  cheque:        { label: "Cheque",        icon: FileText,          tone: "#F59E0B" }, // amber
  cash:          { label: "Cash",          icon: Banknote,          tone: "#10B981" }, // emerald
  other:         { label: "Other",         icon: CircleDollarSign,  tone: "#64748B" }, // slate
};

export function PaymentMethodIcon({ method, className = "h-4 w-4", withLabel = false, size }) {
  const meta = PAYMENT_METHOD_META[method] || PAYMENT_METHOD_META.other;
  const Icon = meta.icon;
  const style = size ? { width: size, height: size, color: meta.tone } : { color: meta.tone };
  if (withLabel) {
    return (
      <span className="inline-flex items-center gap-1.5" data-payment-method={method}>
        <Icon className={className} style={style} strokeWidth={2} />
        <span>{meta.label}</span>
      </span>
    );
  }
  return <Icon className={className} style={style} strokeWidth={2} data-payment-method={method} />;
}

export function methodLabel(method) {
  return (PAYMENT_METHOD_META[method] || PAYMENT_METHOD_META.other).label;
}
